module.exports = __webpack_public_path__ + "static/media/house-5.a152cdf2.jpeg";